import React from 'react';
import { useState, useRef } from 'react';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { Trans } from '@lingui/macro';
import { EStatisticsGender } from '../../../../reducers/data';
import SmallGenderTitle from '../statistics/SmallGenderTitle';

interface IProps {
    selected?: EStatisticsGender,
    allowed: EStatisticsGender[],
    onSelect: (type: EStatisticsGender) => void
}

const FilterGender: React.FC<IProps> = (props) => {
    const ref = useRef<HTMLDivElement>(null)
    
    const [show, setShow] = useState(false)
    
    useOnClickOutside(ref, () => {
        setShow(false)
    })

    let graphs: {
        image: string,
        type: EStatisticsGender
    }[] = []

    if(props.allowed.includes(EStatisticsGender.all)) {
        graphs.push({
            image: '/assets/layout/g-all.png',
            type: EStatisticsGender.all
        })
    }
    
    if(props.allowed.includes(EStatisticsGender.man)) {
        graphs.push({
            image: '/assets/layout/g-man.png',
            type: EStatisticsGender.man
        })
    }
    
    if(props.allowed.includes(EStatisticsGender.woman)) {
        graphs.push({
            image: '/assets/layout/g-woman.png',
            type: EStatisticsGender.woman
        })
    }
    
    return (
        <div className={`element_drop basic to_center col_default offset ${show?'active':''}`} ref={ref}>
            <button 
                type="button" 
                className="btn_basic element_drop_button"
                onClick={() => {
                    setShow(!show)
                }}
            >
                <span><Trans>Gender</Trans></span>
                <svg className="sico drop"><use xlinkHref="/assets/layout/icons.svg#s_ar1_d" /></svg>
            </button>  
            <div className="element_drop_inner">
                <div className="element_drop_arrow"></div>
                <div className="element_drop_content pd-30 pdt-10">
                    <div className="grid flex-nowrap-md">
                        {graphs.map((g,i) => (
                            <label key={i} className="item_image_label col_equal offset wmin190 wmin150_xlm wmin100_mdm">
                                <input 
                                    type="radio" 
                                    name={"gender_" + g.type} 
                                    checked={props.selected === g.type}
                                    onChange={(e) => {
                                        if(e.target.checked) {
                                            props.onSelect(g.type)
                                        }
                                        setShow(false)
                                    }}
                                />
                                <div className="item_image">
                                    <img src={g.image} alt={g.type} className="item_image_img" />
                                    <div className="item_image_desc">
                                        <span><Trans>Gender</Trans></span>
                                        <strong><SmallGenderTitle type={g.type}/></strong>
                                    </div>
                                </div>
                            </label>
                        ))}
                    </div>
                </div>
            </div>                       
        </div> 
    )
}

export default FilterGender